import React, { useState, useEffect } from 'react';
import JotformEmbed from 'react-jotform-embed';

const APIForm = (props) => {   
   return (
       <div className="mb-4">
            <div>
                <JotformEmbed src="https://form.jotform.com/212364017311038" />
            </div>
       </div>
   )
};

export default APIForm;
